import { render, staticRenderFns } from "./KaiButton.vue?vue&type=template&id=1ef148f7&scoped=true&"
var script = {}
import style0 from "./KaiButton.vue?vue&type=style&index=0&id=1ef148f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef148f7",
  null
  
)

export default component.exports